import script from "./addParkAndClub.vue?vue&type=script&setup=true&lang=js"
export * from "./addParkAndClub.vue?vue&type=script&setup=true&lang=js"

import "./addParkAndClub.vue?vue&type=style&index=0&id=2c59252a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c59252a"]])

export default __exports__